import {useRef, useMemo} from "react";
import {getI18n, useTranslation} from "react-i18next";
import ls from "../utils/ls";

export default function useLanguage() {
  const { i18n } = useTranslation();
  
  const lang = useMemo(() => {
    return [
      {
        name: '繁體中文',
        lang: 'tw'
      },
      // {
      //   // name: '简体中文',
      //   lang: 'cn'
      // },
      {
        name: 'English',
        lang: 'en'
      },
    ];
  }, []);
  
  const setLang = (lang, cb) => {
    ls.set('MALLLANG', lang);
    i18n.changeLanguage(lang);
    document.title = getI18n().t(document.title);
    if (cb) {
      cb();
    }
  };
  
  return [lang, setLang];
}
